// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mobile .v-list-item{min-height:50px}.top--100{top:100px!important}.top--50{top:50px!important}", ""]);
// Exports
module.exports = exports;
